import type { SyntheticEvent } from 'react';
import type { InputBaseComponentProps } from '@mui/material';

// Browsers capture whatever is typed into a native `type="password"` input and
// offer to save it together with the nearest text field as a login (LB-5371).
// The passwords in these apps belong to LPs, other users and reporting
// servers, so a password field stays a text input masked with CSS and only
// falls back to the native type where the mask is unsupported (Firefox < 114),
// never showing the secret in clear text.
export const isTextSecuritySupported = typeof CSS !== 'undefined' && CSS.supports('-webkit-text-security', 'disc');

export const getPasswordInputType = (isPasswordVisible: boolean): 'text' | 'password' => (
  isPasswordVisible || isTextSecuritySupported ? 'text' : 'password'
);

// A text input would otherwise get spell checking (Chrome's enhanced spell
// check uploads the text) and keyboard suggestions.
export const passwordInputAttributes: InputBaseComponentProps = {
  autoComplete: 'off',
  spellCheck: false,
  autoCorrect: 'off',
  autoCapitalize: 'none',
};

// Native password inputs refuse to copy, cut or drag their text out; keep
// that while the text is masked.
const blockLeak = (event: SyntheticEvent) => event.preventDefault();

export const getPasswordInputProps = (isPasswordVisible: boolean): InputBaseComponentProps => ({
  ...passwordInputAttributes,
  ...(!isPasswordVisible && {
    onCopy: blockLeak,
    onCut: blockLeak,
    onDragStart: blockLeak,
  }),
});

export const maskedInputStyle = {
  '& input': {
    WebkitTextSecurity: 'disc',
  },
};
